import { Sys } from 'libs/contentful/props';
import Image from 'next/image';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { BadgeOverlayAlignment } from '@/types/constants';
import { cn } from 'utils/styles';

interface BadgeOverlayProps {
  sys?: Sys;
  description?: string;
  fileName?: string;
  url: string;
  badgeOverlayAlignment?: BadgeOverlayAlignment;
}

const BadgeOverlay = ({ sys, description, url, badgeOverlayAlignment }: BadgeOverlayProps) => {
  return (
    <div
      className={cn(
        'flex flex-row absolute z-10 top-0',
        badgeOverlayAlignment === BadgeOverlayAlignment.Left ? 'left-0' : 'right-0',
      )}
      data-testid="badge-overlay">
      <div className="flex w-[64px] h-[64px] sm:w-[80px] sm:h-[80px]" {...liveUpdateAttrs(sys?.id, 'image')}>
        <Image src={url} alt={description ?? ''} width={80} height={80} />
      </div>
    </div>
  );
};

export default BadgeOverlay;
